export default __webpack_public_path__ + "static/media/stars_mini.b45124bb.jpg";